import React from 'react';
import { Box, Typography, Grid, Paper, Stack, Chip } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const socials = [
  {
    name: 'YouTube',
    handle: '@panekopanko',
    url: 'https://youtube.com/@panekopanko',
    desc: 'VODs, speedpaints & hardware teardowns',
    color: '#ff4444',
    emoji: '▶',
    tags: ['Streams', 'VODs', 'Tutorials'],
    stat: '12.4K subs',
  },
  {
    name: 'Twitch',
    handle: 'panekopanko',
    url: 'https://twitch.tv/panekopanko',
    desc: 'Live streams — 3D modelling, CTF & solder sessions',
    color: '#9146ff',
    emoji: '🟣',
    tags: ['Live', 'Chat', 'Drops'],
    stat: 'Live Tue/Wed/Sat',
  },
  {
    name: 'Twitter / X',
    handle: '@panekopanko',
    url: 'https://twitter.com/panekopanko',
    desc: 'WIPs, shitposts, PCB pics & stream announcements',
    color: '#1d9bf0',
    emoji: '✕',
    tags: ['WIPs', 'Announcements'],
  },
  {
    name: 'GitHub',
    handle: 'panekopanko',
    url: 'https://github.com/panekopanko',
    desc: 'Open-source PCB designs, firmware & CTF writeups',
    color: '#f0e6f6',
    emoji: '⌥',
    tags: ['Open Source', 'PCB', 'CTF'],
  },
  {
    name: 'Discord',
    handle: 'panekopanko',
    url: 'https://discord.gg/panekopanko',
    desc: 'Community server — maker chat, CTF team & support',
    color: '#5865f2',
    emoji: '#',
    tags: ['Community', 'Maker', 'CTF'],
  },
    {
    name: 'Fluxer',
    handle: 'panekopanko',
    url: 'https://fluxer.gg/panekopanko',
    desc: 'Opensource Community server — maker chat, CTF team & support',
    color: '#c958f2ff',
    emoji: '#',
    tags: ['Community', 'Maker', 'CTF'],
  },
  {
    name: 'Patreon',
    handle: 'panekopanko',
    url: 'https://patreon.com/panekopanko',
    desc: 'Exclusive posts, source files & monthly rewards',
    color: '#ff424d',
    emoji: '✦',
    tags: ['Members', 'Downloads'],
    stat: 'From €5/mo',
  },
      {
    name: 'BuyMeACoffee',
    handle: 'panekopanko',
    url: 'https://buymeacoffee.com/panekopanko',
    desc: 'Support A Panko',
    color: '#c958f2ff',
    emoji: '#',
    tags: ['Members', 'Merch', 'Mail'],
  },
  {
    name: 'TikTok',
    handle: '@panekopanko',
    url: 'https://tiktok.com/@panekopanko',
    desc: 'Shorts — soldering fails, avatar reveals & hacking clips',
    color: '#ff0050',
    emoji: '♪',
    tags: ['Shorts', 'Clips'],
  },
  {
    name: 'booth.pm',
    handle: 'panekopanko',
    url: 'https://panekopanko.booth.pm',
    desc: 'VRM avatars, overlay packs & stream asset bundles',
    color: '#fc4d50',
    emoji: '🛍',
    tags: ['Avatars', 'Overlays', 'Assets'],
  },
  {
    name: 'Bluesky',
    handle: '@panekopanko.bsky.social',
    url: 'https://bsky.app/profile/panekopanko.bsky.social',
    desc: 'Daily thoughts, art dumps & tech rabbit holes',
    color: '#0085ff',
    emoji: '☁',
    tags: ['Posts', 'Art'],
  },
    {
    name: 'vgen',
    handle: 'panekopanko',
    url: 'https://vgen.co/panekopanko',
    desc: 'hire a panko',
    color: '#e6f6eaff',
    emoji: '⌥',
    tags: ['VRM avatars', 'Commission a panko', 'Merch'],
  },
];

export default function SocialLinks() {
  return (
    <Box
      id="socials"
      sx={{
        py: { xs: 10, md: 14 },
        px: { xs: 3, md: 8 },
        background: 'linear-gradient(180deg, transparent, rgba(255,110,180,0.03), transparent)',
      }}
    >
      <Box sx={{ maxWidth: 1200, mx: 'auto' }}>
        <Typography variant="overline" sx={{ color: 'primary.main', letterSpacing: 6, fontSize: '0.75rem' }}>
          05 — FIND ME
        </Typography>
        <Typography variant="h2" sx={{ fontSize: { xs: '2.5rem', md: '3.5rem' }, mt: 1, mb: 2 }}>
          Socials
        </Typography>
        <Typography variant="body1" sx={{ color: 'text.secondary', mb: 8, maxWidth: 480 }}>
          Every platform has different content — pick your poison.
        </Typography>

        <Grid container spacing={3}>
          {socials.map((s) => (
            <Grid size={{ xs: 12, sm: 6, lg: 4 }} key={s.name}>
              <Paper
                component="a"
                href={s.url}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  p: 3,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 1.5,
                  textDecoration: 'none',
                  background: 'rgba(22,15,32,0.9)',
                  border: '1px solid rgba(255,110,180,0.1)',
                  transition: 'all 0.3s cubic-bezier(0.4,0,0.2,1)',
                  '&:hover': {
                    borderColor: s.color,
                    transform: 'translateY(-5px)',
                    boxShadow: `0 12px 40px ${s.color}22`,
                    '& .social-arrow': { opacity: 1, transform: 'translate(2px, -2px)' },
                    '& .social-icon': { color: s.color, textShadow: `0 0 20px ${s.color}` },
                  },
                }}
              >
                <Stack direction="row" alignItems="flex-start" justifyContent="space-between">
                  <Stack direction="row" spacing={1.5} alignItems="center">
                    <Typography
                      className="social-icon"
                      sx={{
                        fontSize: '1.5rem',
                        color: `${s.color}bb`,
                        lineHeight: 1,
                        transition: 'color 0.3s, text-shadow 0.3s',
                        width: 28,
                        textAlign: 'center',
                      }}
                    >
                      {s.emoji}
                    </Typography>
                    <Box>
                      <Typography variant="subtitle2" sx={{ fontWeight: 700, color: 'text.primary', lineHeight: 1.2 }}>
                        {s.name}
                      </Typography>
                      <Typography variant="caption" sx={{ color: s.color, fontWeight: 600, fontSize: '0.75rem' }}>
                        {s.handle}
                      </Typography>
                    </Box>
                  </Stack>
                  <OpenInNewIcon
                    className="social-arrow"
                    sx={{
                      fontSize: 15,
                      color: 'text.secondary',
                      opacity: 0,
                      transition: 'opacity 0.2s, transform 0.2s',
                      flexShrink: 0,
                      mt: 0.3,
                    }}
                  />
                </Stack>

                <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.65, fontSize: '0.85rem' }}>
                  {s.desc}
                </Typography>

                <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mt: 'auto', pt: 0.5 }}>
                  <Stack direction="row" spacing={0.7} flexWrap="wrap" sx={{ gap: 0.7 }}>
                    {s.tags.map((tag) => (
                      <Chip
                        key={tag}
                        label={tag}
                        size="small"
                        sx={{
                          height: 20,
                          fontSize: '0.65rem',
                          background: `${s.color}12`,
                          border: `1px solid ${s.color}2a`,
                          color: `${s.color}cc`,
                        }}
                      />
                    ))}
                  </Stack>
                  <Typography variant="caption" sx={{ color: 'text.secondary', whiteSpace: 'nowrap', ml: 1, fontSize: '0.72rem' }}>
                    {s.stat}
                  </Typography>
                </Stack>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}
